import React from 'react'
import Container from 'react-bootstrap/Container';
import Table from 'react-bootstrap/Table';
import Tooltip from 'react-bootstrap/Tooltip';
import { Link } from 'react-router-dom';
import {Row, Button } from 'react-bootstrap';
import { FaEdit } from "react-icons/fa";

const TableHeader = () => {
  return (

    <thead>
      <tr>
        <th style={{width:'8%'}}>UOM ID</th>
        <th style={{width:'10%'}}>UOM Abbreviation</th>
        <th className='d-none d-sm-table-cell' style={{width:'60%'}}>UOM Long Description</th>
        <th style={{width:'5%'}}>Edit</th>
      </tr>
    </thead>
  )
}

const TableBody = (props) => {
  if (props.uomsObj) {
    const rows = props.uomsObj.map((row, index) => { 
      return (      
        <tr key={index}>        
          <td>
            {row.id}
          </td>
          <td>  
            {row.unitofmeasureabbrev}
          </td>
          <td className='d-none d-sm-table-cell'>  
            {row.unitofmeasurelongdescription}
          </td>        
          <td>  
            <Button><Link to = {`/edituompage/${row.id}`}><FaEdit color='white'/></Link></Button>      
          </td>              
        </tr>
      )
    })
    return (
      <tbody>
        {rows}
      </tbody>
    )  
  }
  else {
    return null;
  }
}

const renderEditTooltip = (props) => (
  <Tooltip id="button-tooltip" {...props}>
    Click to edit the patient.
  </Tooltip>
);



const UOMsList = (props) => {        
  
  return (
      <>
      <Container>
        <Row>
          <Table style={{verticalAlign:"baseline"}} striped bordered hover size="sm">
            <TableHeader />
            <TableBody uomsObj={props.listOfUOMs} />
          </Table>
        </Row>
        <hr/>
      </Container>
      </>
    );
}

export default UOMsList;